// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AiSuggestion_DispositiveProvisionFragment } from '../../aiDP/graphql/aiDP.generated';
import { gql } from '@apollo/client';
import { AiSuggestion_DispositiveProvisionFragmentDoc } from '../../aiDP/graphql/aiDP.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchBeneficiaryDesignationSuggestionsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type FetchBeneficiaryDesignationSuggestionsQuery = { __typename?: 'Query', beneficiaryDesignationSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', dpBeneficiaryDesignationTier?: Types.AiSuggestionBeneficiaryDesignationTier | null }
        & AiSuggestion_DispositiveProvisionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchBeneficiaryDesignationSuggestions: 'FetchBeneficiaryDesignationSuggestions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchBeneficiaryDesignationSuggestionsDocument = gql`
    query FetchBeneficiaryDesignationSuggestions($entityId: ID!) {
  beneficiaryDesignationSuggestions: aiSuggestions(
    where: {kindIn: [DP_RECIPIENT_V2], acceptanceStatusIsNil: true, hasEntityWith: {id: $entityId}}
  ) {
    edges {
      node {
        ...AISuggestion_DispositiveProvision
        dpBeneficiaryDesignationTier
      }
    }
  }
}
    ${AiSuggestion_DispositiveProvisionFragmentDoc}`;

/**
 * __useFetchBeneficiaryDesignationSuggestionsQuery__
 *
 * To run a query within a React component, call `useFetchBeneficiaryDesignationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBeneficiaryDesignationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBeneficiaryDesignationSuggestionsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useFetchBeneficiaryDesignationSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>(FetchBeneficiaryDesignationSuggestionsDocument, withFetchPolicyContext(options));
      }
export function useFetchBeneficiaryDesignationSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>(FetchBeneficiaryDesignationSuggestionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchBeneficiaryDesignationSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>(FetchBeneficiaryDesignationSuggestionsDocument, withFetchPolicyContext(options));
        }
export type FetchBeneficiaryDesignationSuggestionsQueryHookResult = ReturnType<typeof useFetchBeneficiaryDesignationSuggestionsQuery>;
export type FetchBeneficiaryDesignationSuggestionsLazyQueryHookResult = ReturnType<typeof useFetchBeneficiaryDesignationSuggestionsLazyQuery>;
export type FetchBeneficiaryDesignationSuggestionsSuspenseQueryHookResult = ReturnType<typeof useFetchBeneficiaryDesignationSuggestionsSuspenseQuery>;
export type FetchBeneficiaryDesignationSuggestionsQueryResult = Apollo.QueryResult<FetchBeneficiaryDesignationSuggestionsQuery, FetchBeneficiaryDesignationSuggestionsQueryVariables>;